import { GetPrivateRoomApi } from "@/features/private-room/list/adapters/get-privateroom/get-privateroom";
import { PrivateOfficeResponse } from "@/features/private-room/list/adapters/get-privateroom/get-privateroom.types";
import { privateOfficeService } from "@/services/private-office-service";
import { parseDaysSinceUpdate } from "@/utils/parse-days-since-update";
import { isAxiosError } from "axios";
import { LoaderFunctionArgs, redirect } from "react-router-dom";

export async function privateRoomAdminDetailsLoader({
  params,
}: LoaderFunctionArgs) {
  if (!params.roomId) {
    throw redirect("/private-office/admin");
  }

  try {
    const data = await GetPrivateRoomApi({ id: params.roomId });

    if (!data?.private_office) {
      throw redirect("/private-office/admin");
    }

    let daysSinceUpdate: number | null = null;
    try {
      const results = await privateOfficeService.searchPrivateOfficeById(
        params.roomId,
      );
      daysSinceUpdate = parseDaysSinceUpdate(results[0]?.days_since_update);
    } catch (lookupError) {
      console.error(
        "Failed to fetch days_since_update for private office admin details:",
        lookupError,
      );
    }

    return {
      privateRoom: data.private_office,
      isLoading: false,
      daysSinceUpdate,
    };
  } catch (error) {
    console.error("Failed to load private room admin details:", error);
    if (isAxiosError(error) && error.response?.status === 401) {
      throw error;
    }
    throw redirect("/private-office/admin");
  }
}

export type LoaderData = {
  privateRoom: PrivateOfficeResponse;
  isLoading: boolean;
  daysSinceUpdate: number | null;
};
